"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kyrgystanTranslations = void 0;
var _types = require("../../../types");
const kyrgystanTranslations = exports.kyrgystanTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Нам очень жаль!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'Эта страница в настоящий момент недоступна',
  [_types.ErrorPageTranslationKey.notFound]: 'К сожалению, введенный вами адрес недоступен',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Сиз жетүүгө аракет кылып жаткан баракча чектелген жана бардык критерийлерге жооп берген эмес.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Сураныч, Орифлэймдин колдоо тобуна электрондук почта аркылуу кайрылыңыз:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Суралган URL четке кагылды!'
};
